// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--M7sYz";
export var socialMediaLinks = "footer-module--socialMediaLinks--U5oXy";